module.exports = __webpack_public_path__ + "img/products-motorhome.90f1a752.jpeg";